import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { AbstractService } from "app/services/abstract.service";
import { Observable } from "rxjs";
import { IPaginationResult, IPaginationResultFrequencies } from "app/common/interfaces";
import {  CombinedFilter } from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import OrderPaymentAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/process/order-payment/order-payment.entity";
import { subRoutesByGroupRequestDto, subRoutesFrecuencyResponseDto } from "../customer-route-frequency/dto/sub-route-reports.dto";

const apiUrl = env.API_ROUTING_URL;
const moduleName = "route_reports";

@Injectable({
  providedIn: "root",
})
export class CustomerTerritoriesService extends AbstractService<any, any, any> {

  /** The last filter used to load the list */
  currentFilter: CombinedFilter<OrderPaymentAttributes>;

    constructor(
        http: HttpClient,
    ) {
        super(apiUrl, moduleName, http);
    }

    /**
     * Pagination
     * @param options Pagination options
     * @returns Paginated data
     */
    findAllWithCount(
        dataToSend: subRoutesByGroupRequestDto,
    ): Observable<IPaginationResultFrequencies<subRoutesFrecuencyResponseDto>> {
        const API_URL: string =
        apiUrl +
        `api/${moduleName}/subRoutesByRouteGroups`;
        return this.http.post<IPaginationResultFrequencies<subRoutesFrecuencyResponseDto>>(API_URL, dataToSend);
    }

    /**
     * Export filter wrapper for customer territories
     * @param dataToSend Export filter data
     * @returns Observable with filtered data for export
     */
    filterForExport(
        dataToSend: CombinedFilter<OrderPaymentAttributes>,
    ): Observable<IPaginationResultFrequencies<subRoutesFrecuencyResponseDto>> {
        this.currentFilter = dataToSend;
        const headers = { 'x-ave-ctx': 'export' };
        const API_URL: string = apiUrl + `api/${moduleName}/subRoutesByRouteGroups`;
        return this.http.post<IPaginationResultFrequencies<subRoutesFrecuencyResponseDto>>(
            API_URL,
            dataToSend,
            { headers }
        );
    }
}
